var _rect, _rect2, _path, _path2, _path3, _path4, _path5, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCoffeeTile(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 170,
    height: 128,
    viewBox: "0 0 170 128",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 98.6154,
    height: 98.6154,
    rx: 16,
    transform: "matrix(0.861934 0.50702 -0.861934 0.50702 85 28)",
    fill: "#29B2EA"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 98.6154,
    height: 98.6154,
    rx: 16,
    transform: "matrix(0.861934 0.50702 -0.861934 0.50702 85 20)",
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M62.5 18.3334L67.2167 68.645C67.3767 70.3567 68.815 71.6667 70.535 71.6667H99.4633C101.183 71.6667 102.622 70.3567 102.782 68.645L107.5 18.3334H62.5Z",
    fill: "url(#paint0_linear_1_270)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M108.333 15H61.6667C60.7467 15 60 15.7467 60 16.6667V18.3333H110V16.6667C110 15.7467 109.253 15 108.333 15Z",
    fill: "url(#paint1_linear_1_270)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M103.333 8.33337H66.6666C64.825 8.33337 63.3333 9.82504 63.3333 11.6667V15H106.667V11.6667C106.667 9.82504 105.175 8.33337 103.333 8.33337Z",
    fill: "url(#paint2_linear_1_270)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M106.318 30H63.6817C63.1917 30 62.8067 30.4217 62.8517 30.91L65.4867 59.2433C65.5267 59.6717 65.8867 60 66.3167 60H103.683C104.113 60 104.473 59.6717 104.513 59.2433L107.148 30.91C107.193 30.4217 106.808 30 106.318 30Z",
    fill: "url(#paint3_linear_1_270)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M85 55C90.5228 55 95 50.5228 95 45C95 39.4772 90.5228 35 85 35C79.4772 35 75 39.4772 75 45C75 50.5228 79.4772 55 85 55Z",
    fill: "#35C1F1"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5,
    filter: "url(#filter0_f_1_270)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 85,
    cy: 80,
    rx: 30,
    ry: 10,
    fill: "#29B1EA"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_1_270",
    x: 31,
    y: 46,
    width: 108,
    height: 68,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 12,
    result: "effect1_foregroundBlur_1_270"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1_270",
    x1: 66.2367,
    y1: 17.6317,
    x2: 103.37,
    y2: 63.865,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#35C1F1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#50E6FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1_270",
    x1: 85,
    y1: 15.1167,
    x2: 85,
    y2: 18.3467,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2751A3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.587,
    stopColor: "#17458B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#103680"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1_270",
    x1: 85,
    y1: 8.32004,
    x2: 85,
    y2: 15.0467,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2760A3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.374,
    stopColor: "#2556A0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.668,
    stopColor: "#1E4796"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.920146,
    stopColor: "#144185"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#103680"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_1_270",
    x1: 85,
    y1: -48.515,
    x2: 85,
    y2: 69.0283,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0038FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0192E3"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCoffeeTile);
export default __webpack_public_path__ + "static/media/coffeeTile.7a6b4dacd5f90d48a49a5b432bf62c9f.svg";
export { ForwardRef as ReactComponent };